import { CheckoutService } from '../../services/checkout.service';
import { Order } from '../../../orders/models/order';
import { Router } from '@angular/router';
import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { HttpClient } from '@angular/common/http';
import { OrderService } from '../../../orders/services/order.service';
import { InvoiceComponent } from '../../../orders/views/invoice/invoice.component';

@Component({
    selector: 'order-placed',
    templateUrl: './order-placed.component.html',
    styleUrls: ['../../checkout.component.sass'],
    standalone: false
})
export class OrderPlacedComponent implements OnInit {

  @ViewChild('invoiceContainer', { read: ViewContainerRef, static: true }) invoiceContainer!: ViewContainerRef;
  private destroy$ = new Subject<void>();

  constructor(
    private http: HttpClient,
    private componentFactoryResolver: ComponentFactoryResolver,
    private checkoutService: CheckoutService,
    private orderService: OrderService,
    private router: Router,
  ) { }

  order = new Order();
  orderTypeCode: any;

  getShippingMethod(): string {
    return this.order.getShippingMethodName();
  }

  goToInvoice() {
    var orderId = this.order.getId();
    this.router.navigate([`/orders/${orderId}/invoice`]);
  }

  getOrderPublicId() {
    var publicId = this.order.getNumber();
    if (publicId == 0 && this.checkoutService.summaryOrder != null) {
      publicId = this.checkoutService.summaryOrder.publicId;
    }
    return publicId;
  }

  ngOnInit() {
    // localStorage.removeItem("fedAcc")
    //this.checkoutService.currentOrder$.subscribe(order => this.order = order);
    //this.orderTypeCode = this.checkoutService.getOrderTypeCode();

    this.checkoutService.currentOrder$.pipe(takeUntil(this.destroy$)).subscribe(order => {
      this.order = order;
      const orderId = order.getId();
      this.orderTypeCode = this.checkoutService.getOrderTypeCode();
      this.loadInvoiceComponent(orderId);
    });
  }
  private loadInvoiceComponent(orderId: string) {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(InvoiceComponent);
    this.invoiceContainer.clear();
    const componentRef = this.invoiceContainer.createComponent(componentFactory);

    const invoiceComponentInstance = componentRef.instance as InvoiceComponent;
    invoiceComponentInstance.orderId = orderId;

    this.orderService.invoiceReady$
      .pipe(takeUntil(this.destroy$))
      .subscribe(readyOrderId => {
        if (readyOrderId === orderId) {
          setTimeout(() => this.generateAndSendPdf(), 1000);
        }
      });
  }

  private generateAndSendPdf() {
    const invoiceElement = document.querySelector('.invoice') as HTMLElement;
    if (!invoiceElement) return;

    const noPrintElements = invoiceElement.querySelectorAll('.invoice__title');
    noPrintElements.forEach(el => (el as HTMLElement).style.display = 'none');

    html2canvas(invoiceElement, {
      scale: 2,
      useCORS: true,
    }).then(canvas => {
      //const imgData = canvas.toDataURL('image/jpeg');
      //const pdf = new jsPDF('p', 'mm', 'a4');
      //const pdfWidth = pdf.internal.pageSize.getWidth();
      //const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      //pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight);
      const imgData = canvas.toDataURL('image/jpeg');
      const pdf = new jsPDF('p', 'mm', 'a4');

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgHeight = (canvas.height * pdfWidth) / canvas.width;

      let position = 0;

      while (position < imgHeight) {
        pdf.addImage(
          imgData,
          'JPEG',
          0,
          position === 0 ? 0 : -position,
          pdfWidth,
          imgHeight
        );
        position += pdfHeight;

        if (position < imgHeight) {
          pdf.addPage();
        }
      }
      const pdfBlob = pdf.output('blob');
      //const formData = new FormData();
      //formData.append('pdf', pdfBlob, `invoice_${this.order.publicId}.pdf`);
      this, this.orderService.sendOrderConfirmationEmail(this.order.id, this.order.publicId, pdfBlob).subscribe(
        () => {
          this.invoiceContainer.clear();
        },
        (error) => {
        }
      );
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
